export class FormatModel {
  constructor(
    public id: number = null,
    public label: string = null,
    public codeFormat: string = null // public url: string = null,
  ) {}

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }
}
